import { getToplyneScore } from '../../lib/API/common';
import { AnalyticsUtils } from '../analytics/AnalyticsUtils';
import Intercom, { onShow, onHide, shutdown } from '@intercom/messenger-js-sdk';
export const INTERCOM_APP_ID = process.env.INTERCOM_APP_ID ?? 'fxxlrhi6';
export const DISABLE_FREE_CHAT_FROM_LOCATION = [
    'BR',
    'ES',
    'MX',
    'ID',
    'PK',
    'NG',
    'CO',
    'MA',
    'VN',
    'AR',
    'EG',
    'BD',
    'KE',
    'PL',
    'LK',
    'IL',
    'EC',
    'JO',
    'UA',
    'GH',
    'TN',
    'CZ',
    'LB',
    'KH',
    'HU',
    'HR',
    'KW',
    'CY',
    'BO',
    'LV',
    'RU',
    'SK',
    'UY',
    'CR',
    'SI',
    'CN',
    'PA',
    'PR',
    'MT',
    'PE',
    'OM',
    'AZ',
    'UG',
    'CM',
    'PS',
    'SV',
    'YE',
    'MN',
    'AO',
    'DZ',
    'CD',
    'NP',
    'VE',
    'IQ',
    'GT',
    'ET',
    'AL',
    'SY',
    'AF',
    'KP',
    'FI',
    'LT',
    'JM',
    'BG',
    'CL',
    'QA',
    'DO',
    'TR',
    'DK',
    'RS',
];
export class IntercomChat {
    static maximize() {
        this.addToplyneInSession();
        window.Intercom('show');
    }
    static async addToplyneInSession() {
        const user = AnalyticsUtils.userData;
        if (user) {
            const data = await getToplyneScore(user.id);
            if (window.Intercom && data && data !== -1) {
                window.Intercom('update', {
                    toplyne_score: data,
                });
            }
        }
    }
    static onHide(callback) {
        onHide(() => {
            callback();
        });
    }
    static onShow(callback) {
        onShow(() => {
            callback();
        });
    }
    static shutdown() {
        shutdown();
    }
    static init() {
        if (window) {
            Intercom({
                app_id: INTERCOM_APP_ID,
                hide_default_launcher: false,
            });
        }
    }
    static loadIcon() {
        this.init();
    }
    static load(onReady) {
        this.init();
        if (window.Intercom) {
            this.maximize();
        }
    }
}
